import {
  Component,
  OnInit,
  Output,
  ViewChildren,
  QueryList,
  EventEmitter,
  ViewChild,
} from "@angular/core";
import { AutoCompleteComponent } from "src/app/shared/components/ui/auto-complete.component";
import { UsersSearchParams } from "src/app/shared/models/ui-user.model";
import { DataElement } from "src/app/shared/models/common";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { keyCodes } from "src/app/shared/models/key-codes.model";
import { Select, SelectModule } from "primeng/select";
import { Store } from "@ngrx/store";
import {
  clinicList,
  mngSelectedClinic,
  plantList,
  roleList,
} from "src/app/shared/ngrx/ngrx-selectors";
import { Subject } from "rxjs";
import { ofType, Actions } from "@ngrx/effects";
import { map, take, takeUntil } from "rxjs/operators";
import { GET_CLINIC_USERS } from "src/app/shared/ngrx/ngrx-actions";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { InputWrapComponent } from "src/app/shared/components/ui/input-wrap.component";
import { FormEnhanceDirective } from "src/app/shared/components/ui/form-enhance.directive";
import { ClearMultiComponent } from "src/app/shared/components/ui/clear-multi.component";

@Component({
  selector: "users-filters",
  templateUrl: "./users-filters.component.html",
  styleUrls: ["./users-filters.component.scss"],
  imports: [
    CommonModule,
    FormsModule,
    InputWrapComponent,
    TranslateModule,
    SelectModule,
    FormEnhanceDirective,
    ClearMultiComponent,
  ],
  standalone: true,
})
export class UsersFiltersComponent implements OnInit {
  @Output() onSearch = new EventEmitter<UsersSearchParams>();
  @Output() onCreateUser = new EventEmitter();
  @ViewChildren(Select) hasSearchDropDowns: QueryList<Select>;
  @ViewChildren(AutoCompleteComponent)
  hasAutoCompleteControls: QueryList<AutoCompleteComponent>;

  searchParams: UsersSearchParams;
  username: string;
  selectedRole: DataElement;
  selectedClinic: DataElement;
  selectedPlant: DataElement;
  formBind = this;
  destroy$ = new Subject();

  get roleList(): DataElement[] {
    return this.store.selectSignal(roleList)();
  }

  get clinicList(): DataElement[] {
    return this.store.selectSignal(clinicList)();
  }

  get plantList(): DataElement[] {
    return this.store.selectSignal(plantList)();
  }

  constructor(private readonly store: Store, private actions$: Actions) {
    this.actions$
      .pipe(
        ofType(GET_CLINIC_USERS),
        takeUntil(this.destroy$),
        map(({ }) => {
          this.clearSearch();
        })
      )
      .subscribe();
  }

  ngOnInit(): void {
    if (this.store.selectSignal(mngSelectedClinic)()) {
      this.clearSearch();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(1);
  }

  clearSearch() {
    this.username = "";
    this.selectedClinic = null;
    this.selectedPlant = null;
    this.selectedRole = null;
  }

  search() {
    this.searchParams = {
      username: this.username,
      clinic: this.selectedClinic,
      plant: this.selectedPlant,
      role: this.selectedRole,
      searchId: null,
    };

    this.onSearch.emit(this.searchParams);
  }

  onCreateUserClicked() {
    this.onCreateUser.emit();
  }

  onKeyPress(e: any) {
    if (e.keyCode == keyCodes.enter) {
      this.search();
    }
  }

  onFieldValueChanged(e: any) {
    this.search();
  }
}
